import { Training } from '../models/training';
import { TrainingPathway } from '../models/trainingPathway';

export const isPathway = (training: Training): training is TrainingPathway => training.type === 'pathway';
